import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class CaretRightIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path d="M0 8.946L1.045 10 6 5 1.045 0 0 1.054 3.91 5z"/></svg>
        )
    }
}

export default withCssClassName(CaretRightIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/caret-right-icon.js